import { useMemo } from "react";
import { object, string, ref } from "yup";
import { testPassword } from "src/commun/utils/ValidationsUtils";

export type UpdatePassword = {
  currentPassword: string;
  newPassword: string;
};

const useValidationSchemaInfoPerso = () => {
  return useMemo(() => {
    const requiredMessage = "form.error.notEmpty";
    const invalidMessage = "form.error.invalid";
    const passwordsDifferents = "form.error.passwordDoesntMatch";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<UpdatePassword>().shape({
      currentPassword: string().required(requiredMessage),
      newPassword: string().required(requiredMessage)
        .test("test-password", invalidMessage, value => testPassword(value)),
      newPasswordConfirmation: string().when("newPassword", (password, field) =>
        password ? field.required(requiredMessage).oneOf([ref('newPassword')], passwordsDifferents) : field),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaInfoPerso;
